import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { Header } from '@/components/layout/header'
import { Footer } from '@/components/layout/footer'
import { Hero } from '@/components/sections/hero'
import { Features } from '@/components/sections/features'
import { Customization } from '@/components/sections/customization'
import { FinalCTA } from '@/components/sections/final-cta'
import { AskAnythingWidget } from '@/components/widgets/AskAnythingWidget'
import AuthPage from './pages/AuthPage'
import AuthCallback from './pages/AuthCallback'
import DashboardPage from './pages/DashboardPage'
import ProtectedRoute from './components/auth/ProtectedRoute'

function HomePage() {
  return (
    <>
      <Header />
      <main className="main-content">
        <Hero />
        <Features />
        <Customization />
        <FinalCTA />
      </main>
      <Footer />
      <AskAnythingWidget />
    </>
  )
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
